<template>
  <div class="items-center flex gap-x-3 max-w-full">
    <button
      class="disabled:text-s-500 hidden text-xs font-semibold lg:block"
      :disabled="currentPage === 1"
      @click="firstPage"
    >
      First
    </button>
    <div
      class="flex flex-wrap justify-center items-center rounded lg:border lg:bg-white gap-1"
    >
      <button
        class="mr-1 disabled:opacity-30"
        :disabled="currentPage === 1"
        @click="previousPage"
      >
        <ChevronCircleLeft class="size-6" />
      </button>
      <span
        v-for="page in totalPages"
        :key="page"
        class="flex size-7 cursor-pointer items-center justify-center rounded border p-1 font-semibold lg:h-auto lg:w-auto lg:rounded-none lg:border-none"
        :class="{
          'border-p-200 lg:bg-p-200': page === currentPage,
          'border-[#a3a5ae]': page !== currentPage,
        }"
        @click="changePage(page)"
      >
        {{ page }}
      </span>
      <button
        class="disabled:opacity-30"
        :disabled="currentPage === totalPages"
        @click="nextPage"
      >
        <ChevronCircleRight class="size-6" />
      </button>
    </div>
    <button
      class="disabled:text-s-500 hidden text-xs font-semibold lg:block"
      :disabled="currentPage === totalPages"
      @click="lastPage"
    >
      Last
    </button>
  </div>
</template>

<script setup lang="ts">
import ChevronCircleRight from '@/assets/icons/ChevronCircleRight.svg'
import ChevronCircleLeft from '@/assets/icons/ChevronCircleLeft.svg'

const props = defineProps<{
  totalRecords: number
  pageSize: number
  currentPage: number
}>()

const emit = defineEmits<{
  'page-change': [number]
}>()

const totalPages = computed(() =>
  Math.ceil(props.totalRecords / props.pageSize),
)

function changePage(page: number) {
  emit('page-change', page)
}

function lastPage() {
  emit('page-change', totalPages.value)
}

function firstPage() {
  emit('page-change', 1)
}

function previousPage() {
  if (props.currentPage > 1) {
    emit('page-change', props.currentPage - 1)
  }
}

function nextPage() {
  if (props.currentPage < totalPages.value) {
    emit('page-change', props.currentPage + 1)
  }
}
</script>
